<div class="payment-wrapper">

    <!-- VERIFYING -->
    <div class="payment-card" *ngIf="state === PaymentState.VERIFYING">

        <div class="spinner"></div>

        <h2>Verifying Your Transaction</h2>
        <p>Please wait while we confirm your order.</p>

        <div class="progress-container">
            <div class="progress-bar" [style.width.%]="progressPercent">
            </div>
        </div>

        <p class="time-text">
            This may take up to
            <strong>{{ remainingSeconds }}</strong>
            seconds
        </p>

        <p class="sub-text">
            Do not refresh or close this page.
        </p>
    </div>

    <!-- ORDER PENDING -->
    <div class="payment-card warning" *ngIf="state === PaymentState.PAYMENT_DONE_ORDER_PENDING">

        <h2>Payment Successful</h2>
        <p>
            Your payment was successful, but your order is still being processed.
        </p>

        <p class="sub-text">
            If the order is not confirmed within a few minutes,
            please contact support & check your payment history.
        </p>

        <button (click)="goToHome()">Check Payment History</button>
    </div>

</div>